import React, { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { LoadingAnimation } from 'components/loading-animation';
import { LoadingContainer } from 'components/loading-animation/loading-container';
import { useAuthRedirects } from 'hooks/auth/use-auth-redirects';
import { useAuthContext } from 'state/auth';
import { useBluecodeContext } from 'state/bluecode';
import { routes } from 'utils/routing';

export const BkPay = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();
  const { isBluecodeInitialized, openBluecodeView, isBluecodeViewOpen } = useBluecodeContext();

  useAuthRedirects();

  useEffect(() => {
    if (!isAuthenticated() || !isBluecodeInitialized) {
      return;
    }

    if (isBluecodeViewOpen) {
      navigate(routes.base);
    }

    openBluecodeView();
  }, [isBluecodeInitialized, isAuthenticated, navigate, openBluecodeView, isBluecodeViewOpen]);

  return (
    <LoadingContainer>
      <LoadingAnimation fillColor={Styles.color.primary} />
    </LoadingContainer>
  );
};
